import { render, staticRenderFns } from "./export.vue?vue&type=template&id=a5139c80&scoped=true&"
import script from "./export.vue?vue&type=script&lang=js&"
export * from "./export.vue?vue&type=script&lang=js&"
import style0 from "./export.vue?vue&type=style&index=0&id=a5139c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5139c80",
  null
  
)

export default component.exports